import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "dstore-service";

export default {
    saveSettings(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/api/cms/dstore/settings/save",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    viewSettings() {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/v1/api/cms/dstore/settings",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    saveFees(param) {
        console.log(param);
        return new Promise((resolve, reject) => {
            console.log(param);
            api.post(
                BASE_SERVICE_URL + "/v2/cms/estore/fee/add",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    viewFees() {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/v2/cms/estore/fee/list",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    deleteFees(uuid) {
        return new Promise((resolve, reject) => {
            api.delete(
                BASE_SERVICE_URL + "/v2/cms/estore/fee/delete/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getBrands() {
        return new Promise((resolve, reject) => {
            api.get("organization-service/brand/list", auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getLoyaltyVisibility() {
        return new Promise((resolve, reject) => {
            api.get("merchant-service/cms/loyalty/visibility", auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    }
};
